export abstract class ObjectUtil {
    public static isNull(obj: object | null | undefined): boolean {
        return null == obj || undefined == obj;
    }

    public static isNotNull(obj: object | null | undefined): boolean {
        return !this.isNull(obj);
    }
}
